import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import IconBase from "../IconBase";
var LinkedIn = function(_param) {
    var _width = _param.width, width = _width === void 0 ? 24 : _width, _height = _param.height, height = _height === void 0 ? 24 : _height, _color = _param.color, color = _color === void 0 ? "white" : _color, props = _object_without_properties(_param, [
        "width",
        "height",
        "color"
    ]);
    return /*#__PURE__*/ _jsx(IconBase, _object_spread_props(_object_spread({
        $styles: {
            width: width,
            height: height
        },
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M19.0002 2.00012L5 2.00012C3 2.00012 2 3.00012 2 5.00012L2.00059 19.0001C2.00059 21.0001 3.00021 22.0001 5.00021 22.0001H19.0002C21.0002 22.0001 22.0002 21.0001 22.0002 19.0001V5.00012C22.0002 3.00012 21.0002 2.00012 19.0002 2.00012ZM8.66687 17.8335H6.16687V8.66679H8.66687V17.8335ZM7.41687 7.61012C6.61187 7.61012 5.95854 6.95179 5.95854 6.14012C5.95854 5.32845 6.61187 4.67012 7.41687 4.67012C8.22187 4.67012 8.87521 5.32845 8.87521 6.14012C8.87521 6.95179 8.22271 7.61012 7.41687 7.61012ZM18.6669 17.8335H16.1669V13.1635C16.1669 10.3568 12.8335 10.5693 12.8335 13.1635V17.8335H10.3335V8.66679H12.8335V10.1376C13.9969 7.98262 18.6669 7.82346 18.6669 12.201V17.8335Z",
            fill: color
        })
    }));
};
export default LinkedIn;
